export const guardianRelationshipOptions = [
  { value: 'father', label: '父' },
  { value: 'mother', label: '母' },
  { value: 'grandfather', label: '祖父' },
  { value: 'grandmother', label: '祖母' },
  { value: 'uncle', label: '叔父' },
  { value: 'aunt', label: '叔母' },
  { value: 'other', label: 'その他' },
];

export const getGuardianRelationshipLabel = (value: string) => {
  return guardianRelationshipOptions.find((option) => option.value === value)?.label || '';
};
